import React, { useEffect, useState } from "react";

import "../../VerifyMobile/verifyMobileEmail.css";
import "../EmailOtp/EnterEmailOtp.css";

import axios from "../../../../axios";
import VerifyMobileEmail from "../../VerifyMobile/VerifyMobileEmail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function EnterEmailOtp({
  registerState,
  setIsEmailValidated,
  setVerifymail,
}) {
  const [otpValue, setOtpValue] = useState("");
  const [isVailidatedEmail, setIsValidatedEmail] = useState({});
  const [continuebnt, setContinuebtn] = useState(true);
  const emailId = JSON.parse(localStorage.getItem("Email"));

  const schoolCode = localStorage.getItem("schoolCode");
  const schoolAssignedId = localStorage.getItem("schoolAssignedId");
  const [iswait, setIsWait] = useState(false);

  const [verify] = useState();
  //  timer otp js

  //Increase the minute limit for otp
  const [minutes, setMinutes] = useState(2);
  //Increase the second limit for otp
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const resendOTP = async () => {
    setIsWait(true);
    try {
      await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
        school_assigned_id: schoolAssignedId,
        school_code: schoolCode,
      });
      setMinutes(2);
      setSeconds(60);
      setOtpValue("");
      setIsValidatedEmail("");
      setIsWait(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsWait(false);
    }
  };

  // verify otp update

  const handleOtpChange = async (e) => {
    try {
      const newValue = e.target.value.replace(/[^0-9]/g, "");
      setOtpValue(newValue);
      setContinuebtn(true);
    } catch (error) {}
  };

  useEffect(() => {
    /^\d{6}$/.test(otpValue) ? setContinuebtn(false) : setContinuebtn(true);

    if (otpValue === "") {
      setIsValidatedEmail("");
    }
  }, [otpValue]);

  //  this useEffect for remove invalid otp wehn time out
  useEffect(() => {
    if (seconds === 0) {
      setIsValidatedEmail("");
      setOtpValue("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [seconds]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (/^\d{6}$/.test(otpValue)) {
      try {
        const res = await axios.post(`/api/v1/teacherAuth/validateEmailOtp`, {
          school_assigned_id: schoolAssignedId,
          school_code: schoolCode,
          otp: otpValue,
        });
        // res && setIsValidatedEmail(res.data)
        setIsEmailValidated(res.data.status);
        setVerifymail(false);
      } catch (error) {
        setIsValidatedEmail(error.response.data);
        console.log(error);
      }
    }
  };

  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== "string") return email;

      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = "*".repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split(".");
      const maskedDomainMiddle = "*".repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <span>{maskEmail(email)}</span>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };

  return (
    <div className="TotalContainer">
      <div className="MainContainer  p-0  d-md-flex ">
        <div className="banner_box col-md-3 col-12 p-0">
          <img
            className="banner_img "
            src="/Register-img/baner_img.jpg"
            alt="banner img"
          ></img>
        </div>
        {/* Here I added code for back to the page */}
        <FontAwesomeIcon
          onClick={() => {
            setVerifymail(false);
          }}
          icon={faArrowLeft}
          style={{ fontSize: "25px", margin: "10px", cursor: "pointer" }}
        />

        <div className="form_box_verify  col-md-9 col-9 p-0">
          <div style={{ width: "45%" }}>
            <div className="total_logo_regist">
              <img
                className="logo_EmailOtp"
                src="/Register-img/Register_logo.png"
                alt="register logo"
              ></img>
            </div>
            <div className="title_regis">Enter OTP</div>
            {/* <div className="otpMail">OTP sent to {registerState.emailid}</div> */}
            <div className="text-center mb-3 mt-3" style={{ color: "gray" }}>
              {registerState?.emailid || registerState?.contactN ? (
                <>
                  An OTP has been sent to{" "}
                  {registerState?.contactN && (
                    <>
                      your WhatsApp number{" "}
                      <span className="font-medium">
                        +91 {maskPhoneNumber(registerState?.contactN)}
                      </span>
                    </>
                  )}
                  {registerState?.contactN && registerState?.emailid && " and "}
                  {registerState?.emailid && (
                    <>
                      your email{" "}
                      <span className="font-medium">
                        {MaskedEmail(registerState?.emailid)}
                      </span>
                    </>
                  )}
                  <br /> .Please enter the code to proceed.
                </>
              ) : (
                "Mobile number and Email id are not registered."
              )}
            </div>
            <form>
              <div>
                <div>
                  <div className="input_box_otp ">
                    {seconds === 0 ? (
                      <input
                        id="otp_ip_enter_Email"
                        placeholder="Enter OTP"
                        disabled={true}
                      />
                    ) : (
                      <input
                        id="otp_ip_enter_Email"
                        placeholder="Enter OTP"
                        value={otpValue}
                        onChange={handleOtpChange}
                        maxLength={6}
                        pattern="[0-9]*"
                        autocomplete="off"
                      />
                    )}
                    <span className="otp_timer_count">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    {isVailidatedEmail.status === false && (
                      <div className="invailidOtp">Invalid OTP entered</div>
                    )}
                    {minutes === 0 && seconds === 0 && (
                      <div className="invailidOtp">OTP Timed out</div>
                    )}
                  </div>
                  <div>
                    <input
                      id={continuebnt ? "btn_disabled" : "otp_btn"}
                      type="submit"
                      className="col-md-12 col-12 btn btn-primary my-3"
                      value="Continue"
                      disabled={continuebnt}
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="d-flex justify-content-center mt-4">
              <button
                className="Resend_otp_email"
                disabled={seconds > 0 || minutes > 0}
                style={{
                  color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#F77F00",
                }}
                onClick={resendOTP}
              >
                {iswait ? "Please wait..." : "Resend OTP"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {verify && <VerifyMobileEmail />}
    </div>
  );
}
